//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import log from 'loglevel';
import debounce from 'lodash/debounce';
import KResponsiveWindowMixin from './KResponsiveWindowMixin';

// check for Nuxt.js SSR
const nuxtServerSideRendering = process && process.server;

/**
 * Used to focus attention on a singular action/task
 */
export default {
  name: 'KModal',
  mixins: [KResponsiveWindowMixin],
  props: {
    /**
     * The title of the modal
     */
    title: {
      type: String,
      required: true,
    },
    /**
     * The text of the submit button
     */
    submitText: {
      type: String,
      required: false,
    },
    /**
     * The text of the cancel button
     */
    cancelText: {
      type: String,
      required: false,
    },
    /**
     * Disable the submit button
     */
    submitDisabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Disable the cancel button
     */
    cancelDisabled: {
      type: Boolean,
      default: false,
    },
    /**
     * How wide the modal should be.
     * Small - 300 px.
     * Medium - 450px.
     * Large - 100%.
     */
    size: {
      type: String,
      required: false,
      default: 'medium',
      validator(val) {
        return ['small', 'medium', 'large'].includes(val);
      },
    },
    /**
     * Toggles error message indicator in title
     */
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lastFocus: null,
      maxContentHeight: '1000',
      contentHeight: 0,
      scrollShadow: false,
      delayedEnough: false,
    };
  },
  computed: {
    modalSizeStyles() {
      return {
        'max-width': `${this.maxModalWidth - 32}px`,
        'max-height': `${this.windowHeight - 32}px`,
      };
    },
    maxModalWidth() {
      if (this.windowWidth < 1000) {
        return this.windowWidth;
      }
      return 1000;
    },
    contentSectionMaxHeight() {
      return {
        'max-height': `${this.maxContentHeight}px`,
        height: `${this.contentHeight}px`,
      };
    },
  },
  created() {
    if (this.$props.cancelText && !this.$listeners.cancel) {
      log.error(
        'A "cancelText" has been set, but there is no "cancel" listener. The "cancel" button may not work correctly.'
      );
    }
    if (this.$props.submitText && !this.$listeners.submit) {
      log.error(
        'A "submitText" has been set, but there is no "submit" listener. The "submit" button may not work correctly.'
      );
    }
  },
  beforeMount() {
    this.lastFocus = document.activeElement;
  },
  mounted() {
    if (nuxtServerSideRendering) {
      return;
    }
    // Remove scrollbars from the <html> tag, so user's can't scroll while modal is open
    window.document.documentElement.style['overflow'] = 'hidden';
    this.$nextTick(() => {
      if (this.$refs.modal && !this.$refs.modal.contains(document.activeElement)) {
        this.focusModal();
      }
    });
    window.addEventListener('focus', this.focusElementTest, true);
    window.setTimeout(() => (this.delayedEnough = true), 500);
  },
  updated() {
    this.updateContentSectionStyle();
  },
  destroyed() {
    if (nuxtServerSideRendering) {
      return;
    }
    // Restore scrollbars to <html> tag
    window.document.documentElement.style['overflow'] = '';
    window.removeEventListener('focus', this.focusElementTest, true);
    // Wait for events to finish propagating before changing the focus.
    // Otherwise the `lastFocus` item receives events such as 'enter'.
    window.setTimeout(() => this.lastFocus.focus());
  },
  methods: {
    /**
     * Calculate the max-height of the content section of the modal
     * If there is not enough vertical space, create a vertically scrollable area and a
     * scroll shadow
     */
    updateContentSectionStyle: debounce(function() {
      if (this.$refs.title && this.$refs.actions) {
        if (Math.abs(this.$refs.content.scrollHeight - this.contentHeight) >= 8) {
          this.contentHeight = this.$refs.content.scrollHeight;
        }
        const maxContentHeightCheck =
          this.windowHeight -
          this.$refs.title.clientHeight -
          this.$refs.actions.clientHeight -
          32;
        // to prevent max height from toggling between pixels
        // we set a threshold of how many pixels the height should change before we update
        if (Math.abs(maxContentHeightCheck - this.maxContentHeight) >= 8) {
          this.maxContentHeight = maxContentHeightCheck;
          this.scrollShadow = this.maxContentHeight < this.$refs.content.scrollHeight;
        }

        // make sure that overflow-y won't be updated to 'auto' if this
        // function is running for the first time
        // (otherwise Firefox would add a vertical scrollbar right away)
        if (this.$refs.content.clientHeight !== 0) {
          // add a vertical scrollbar if content doesn't fit
          if (this.$refs.content.scrollHeight > this.$refs.content.clientHeight) {
            this.$refs.content.style.overflowY = 'auto';
          }
        }
      }
    }, 50),
    emitCancelEvent() {
      if (!this.cancelDisabled) {
        // Emitted when the cancel button is clicked or the esc key is pressed
        this.$emit('cancel');
      }
    },
    emitSubmitEvent() {
      if (!this.submitDisabled) {
        // Emitted when the submit button or the enter key is pressed
        this.$emit('submit');
      }
    },
    handleEnter() {
      if (this.delayedEnough) {
        this.emitSubmitEvent();
      }
    },
    focusModal() {
      this.$refs.modal.focus();
    },
    focusElementTest(event) {
      const { target } = event;
      const noopOnFocus =
        target === window || // switching apps
        !this.$refs.modal || // if $refs.modal isn't available
        target === this.$refs.modal || // addresses #3824
        this.$refs.modal.contains(target.activeElement);
      if (noopOnFocus) {
        return;
      }
      // Fixes possible infinite recursion when disconnection snackbars appear
      // along with KModal (#6301)
      const $coreSnackbar = document.getElementById('coresnackbar');
      if ($coreSnackbar && $coreSnackbar.contains(target)) {
        return;
      }
      // focus has escaped the modal - put it back!
      if (!this.$refs.modal.contains(target)) {
        this.focusModal();
      }
    },
  },
  $trs: {
    // error alerts
    errorAlert: 'Error in { title }',
  },
};

